export const QUOTE_FORM_ROUTE = 'quotes.show'
export const POLICY_FORM_ROUTE = 'policies.show'
export const POLICY_SUPER_EDIT_ROUTE = 'policies.locked.super-edit'
export const FORM_ROUTES = [
    QUOTE_FORM_ROUTE,
    POLICY_FORM_ROUTE,
    POLICY_SUPER_EDIT_ROUTE,
]
